module.exports = __webpack_public_path__ + "static/deals-for-you-submit-a12ad38c6184093eacc6ba099635de78.png";